import { Trans } from 'react-i18next';
import { BaseModal, Button } from '@anytag/shared-atoms';
import { useQueryHelper, useToggleState } from '@anytag/shared-hooks';
import { namedOperations, useApproveCmsInvoiceMutation } from '@anytag/graphql';
import { useYoutubeCMSInvoicesFilter } from '../YoutubeCMSInvoicesFilter';

interface ApproveButtonProps {
  hasNoData?: boolean;
}

export const ApproveButton = ({ hasNoData }: ApproveButtonProps) => {
  const modal = useToggleState();
  const { filter } = useYoutubeCMSInvoicesFilter();
  const { t, enqueueSnackbar } = useQueryHelper();
  const { callApproveCmsInvoice, loading } = useApproveCmsInvoiceMutation({
    refetchQueries: [namedOperations.Query.YoutubeCmsInvoiceList]
  });

  const handleApprove = async () => {
    try {
      await callApproveCmsInvoice({ variables: { input: { month: filter.month } } });
    } catch (error) {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    } finally {
      modal.close();
    }
  };

  return (
    <>
      <Button
        variant="solid"
        onClick={modal.open}
        disabled={hasNoData}
        title={t('Button.Approve')}
        css={{ padding: '0 24px', minWidth: '142px' }}
      />

      <BaseModal
        open={modal.status}
        onClose={modal.close}
        title={t('Invoice Export')}
        description={<Trans i18nKey="Modal.approveInvoiceDescription" components={{ br: <br /> }} />}
        footer={{
          cancelButton: { onClick: modal.close },
          submitButton: {
            onClick: handleApprove,
            title: t('Button.Approve'),
            loading: { status: loading, showIcon: true }
          }
        }}
      />
    </>
  );
};
